import * as z from 'zod';
import { ViewMode } from '../../viewMode/model';

export const schemaV4 = z.object({
  version: z.literal(4),
  data: z.object({
    app: z
      .object({
        sidebarExpanded: z.boolean().optional(),
      })
      .optional(),
    category: z.object({
      selectedId: z.string(),
      expandedKeys: z.string().array(),
    }),
    extension: z.object({
      selectedIds: z.string().array(),
      expandedKeys: z.string().array(),
    }),
    finder: z.object({
      selected: z
        .object({
          ids: z.number().array(),
          firstId: z.number().optional(),
          lastId: z.number().optional(),
        })
        .optional(),
      detailsVisible: z.boolean(),
    }),
    project: z.object({
      selectedIds: z.number().array(),
      expanded: z.boolean().optional(),
    }),
    search: z.object({
      text: z.string(),
      uploadData: z
        .object({ id: z.number(), fileName: z.string(), similarAssetId: z.number().optional() })
        .optional(),
      options: z
        .object({
          searchInLayers: z.boolean().optional(),
          searchInArchives: z.boolean().optional(),
          searchWithAi: z.boolean().optional(),
        })
        .optional(),
    }),
    sorting: z.object({
      order: z.string(),
      fieldKey: z.string(),
    }),
    tag: z.object({
      selectedIds: z.number().array(),
      expandedMode: z.boolean(),
    }),
    viewMode: z
      .object({
        value: z.union([z.literal(ViewMode.assets), z.literal(ViewMode.creatives)]).optional(),
        expanded: z.boolean().optional(),
      })
      .optional(),
    viewer: z
      .object({
        creative: z.object({ id: z.number(), name: z.string() }).optional(),
      })
      .optional(),
  }),
});
